// Table utilities for RichTextEditable toolbar
export const getCurrentTable = (
    contentRef: React.RefObject<HTMLDivElement>
): HTMLTableElement | null => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return null;

    let currentNode: Node | null = selection.getRangeAt(0).startContainer;
    while (currentNode && currentNode !== contentRef.current) {
        if (
            currentNode.nodeType === Node.ELEMENT_NODE &&
            (currentNode as Element).tagName.toLowerCase() === 'table'
        ) {
            return currentNode as HTMLTableElement;
        }
        currentNode = currentNode.parentNode;
    }
    return null;
};

export const getCurrentCell = (
    contentRef: React.RefObject<HTMLDivElement>
): HTMLTableCellElement | null => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return null;

    let currentNode: Node | null = selection.getRangeAt(0).startContainer;
    while (currentNode && currentNode !== contentRef.current) {
        if (currentNode.nodeType === Node.ELEMENT_NODE) {
            const tagName = (currentNode as Element).tagName.toLowerCase();
            if (tagName === 'td' || tagName === 'th') {
                return currentNode as HTMLTableCellElement;
            }
        }
        currentNode = currentNode.parentNode;
    }
    return null;
};

export const createTable = (rows: number, cols: number): HTMLTableElement => {
    const table = document.createElement('table');
    table.style.cssText = `
        border-collapse: collapse;
        width: 100%;
        min-width: 500px;
        margin: 10px 0;
    `;

    const tbody = document.createElement('tbody');

    for (let i = 0; i < rows; i++) {
        const row = document.createElement('tr');

        for (let j = 0; j < cols; j++) {
            const cell = document.createElement('td');
            cell.style.cssText = `
                border: 1px solid #000;
                padding: 8px;
                min-width: 50px;
                min-height: 20px;
            `;
            cell.innerHTML = '&nbsp;';
            row.appendChild(cell);
        }

        tbody.appendChild(row);
    }

    table.appendChild(tbody);
    return table;
};

export const addTableColumn = (
    currentCell: HTMLTableCellElement,
    currentTable: HTMLTableElement
): void => {
    const cellIndex = Array.from(currentCell.parentElement!.children).indexOf(currentCell);
    const rows = currentTable.querySelectorAll('tr');

    rows.forEach((row) => {
        const newCell = document.createElement('td');
        newCell.style.cssText = `
            border: 1px solid #000;
            padding: 8px;
            min-width: 50px;
            min-height: 20px;
        `;
        newCell.innerHTML = '&nbsp;';

        if (row.children.length > cellIndex + 1) {
            row.insertBefore(newCell, row.children[cellIndex + 1]);
        } else {
            row.appendChild(newCell);
        }
    });
};

export const removeTableColumn = (
    currentCell: HTMLTableCellElement,
    currentTable: HTMLTableElement
): void => {
    const cellIndex = Array.from(currentCell.parentElement!.children).indexOf(currentCell);
    const rows = currentTable.querySelectorAll('tr');

    // Don't remove if it's the last column
    if (rows[0] && rows[0].children.length > 1) {
        rows.forEach((row) => {
            if (row.children[cellIndex]) {
                row.removeChild(row.children[cellIndex]);
            }
        });
    }
};

export const addTableRow = (currentCell: HTMLTableCellElement): void => {
    const currentRow = currentCell.parentElement as HTMLTableRowElement;
    const colCount = currentRow.children.length;

    const newRow = document.createElement('tr');

    for (let i = 0; i < colCount; i++) {
        const newCell = document.createElement('td');
        newCell.style.cssText = `
            border: 1px solid #000;
            padding: 8px;
            min-width: 50px;
            min-height: 20px;
        `;
        newCell.innerHTML = '&nbsp;';
        newRow.appendChild(newCell);
    }

    // Insert after current row
    if (currentRow.nextSibling) {
        currentRow.parentElement!.insertBefore(newRow, currentRow.nextSibling);
    } else {
        currentRow.parentElement!.appendChild(newRow);
    }
};

export const removeTableRow = (currentCell: HTMLTableCellElement): void => {
    const currentRow = currentCell.parentElement as HTMLTableRowElement;
    const tbody = currentRow.parentElement!;

    // Don't remove if it's the last row
    if (tbody.children.length > 1) {
        tbody.removeChild(currentRow);
    }
};
